import React, { useEffect } from 'react'
import { Grid } from "@mui/material"

import { useSearchAnalyticsDateRangeInfo, useSearchAnalyticsMonthInfo } from "Pages/Main/Page/@hooks"
import SearchAnalyticsCards from "Pages/Main/Page/Content/Cards"
import SearchAnalyticsTables from "Pages/Main/Page/Content/DataTables"
import SearchAnalyticsPieChart from "Pages/Main/Page/Content/PieChart"
import SearchAnalyticsColumnsChart from "Pages/Main/Page/Content/ColumnChart"
import { clearSignals } from "Pages/Main/Page/@signals"


export default function SearchAnalyticsContent() {

	useEffect(() => {
		return () => {
			clearSignals()
		}
	}, [])

	const {
		monthSearches,
		columnChartData,
		isMonthLoading
	} = useSearchAnalyticsMonthInfo()

	const {
		dateRangeSearches,
		userSiteTableData,
		dateUserTableData,
		isDateRangeLoading,
		pieChartData,
	} = useSearchAnalyticsDateRangeInfo()

	return <Grid container spacing={2}>
		<Grid item xs={2}>
			<SearchAnalyticsCards dateRangeSearches={dateRangeSearches} monthSearches={monthSearches} isLoading={isMonthLoading}/>
		</Grid>
		<Grid item xs={5}>
			<SearchAnalyticsTables
				isDateRangeLoading={isDateRangeLoading}
				userSiteTableData={userSiteTableData}
				dateUserTableData={dateUserTableData}
			/>
		</Grid>
		<Grid item xs={5}>
			<SearchAnalyticsPieChart data={pieChartData} isDateRangeLoading={isDateRangeLoading}/>
		</Grid>
		<Grid item xs={12}>
			<SearchAnalyticsColumnsChart data={columnChartData} isMonthLoading={isMonthLoading}/>
		</Grid>
	</Grid>
}